import { useContext, useState } from "react"
import { OpenDrawerContext } from "../../custom-contexts/open-drawer-context/open-drawer-context";

const OpenDrawerProvider = ({children}) => {
    const [opened, setOpened] = useState(false);

    return (
        <OpenDrawerContext.Provider
            value={{opened, setOpened}}
            >{children}
        </OpenDrawerContext.Provider>
    );
}

export default OpenDrawerProvider;

export const useOpenDrawer = () => {
    return useContext(OpenDrawerContext);
};
